import { observer } from 'mobx-react';
import dynamic from 'next/dynamic';

import { Button } from 'components/elements/button';
import { NewLoader } from 'components/elements/loader/loader';
import MinimalLogo from 'components/elements/minimalLogo';
import { useModal } from 'components/elements/modal';
import LoginModule from 'components/modules/login';
import { useGlobalStore, useHasAuth } from 'lib/DataStore';
import { Suspense } from 'react';
import { useSearchListing } from '../hooks/useSearchListing';
import SaveSearchDirectAssign from './FilterBox/SaveSearchDirectAssign';
import Pagination from './pagination';
import SideBar from './sideBar';
import TopMainContnt from './topMainContnt';

const StorySection = dynamic(() => import('./storySection'), {
  ssr: false,
  suspense: true,
});

const PlpListing = dynamic(() => import('./plpListing'));

function MainContent() {
  const { plpListing } = useSearchListing();

  const { userDevice } = useGlobalStore();

  const { openModal } = useModal({
    id: 'saveSearchDirectAssign',
    content: ({ closeModal }) => (
      <SaveSearchDirectAssign closeModal={closeModal} />
    ),
  });

  const hasAuth = useHasAuth();

  const loginModal = useModal({
    id: 'login-modal-plp',
    closeable: false,
    content: (
      <LoginModule
        isModal
        modalId='login-modal-plp'
        onLogedIn={() =>
          new Promise((resolve, reject) => {
            try {
              resolve(true);
              openModal();
            } catch (error) {
              reject(false);
            }
          })
        }
      />
    ),
  });

  return (
    <>
      {/*بخش محتوای اصلی صحفه شامل استوری و لیست فایل ها */}
      <div className='md:flex md:space-x-4 md:space-x-reverse'>
        <div className='w-full md:max-w-[80%]'>
          <Suspense
            fallback={
              <NewLoader className='flex items-center justify-center min-h-[148px]' />
            }
          >
            <StorySection />
          </Suspense>
          <TopMainContnt />
          <PlpListing />
        </div>
        {/*قسمت سئو و تبلیغات سمت چپ*/}
        <SideBar />
      </div>
      {/*  بخش صحفه بندی انتهای صفحه */}
      {plpListing && plpListing.result && plpListing.result.length > 0 && <Pagination />}

      {/*بخش یافتن ملک از طریق مشاور*/}
      <div className='flex flex-col items-center justify-center py-4 space-y-4 bg-grey-100 '>
        <MinimalLogo className='h-12' />
        <p className='text-display-xs'>یافتن ملک از طریق مشاورین املاک</p>
        <p className='text-gray-500'>جستجوی من را به مشاورین بسپار</p>
        <Button
          onClick={() => {
            if (!hasAuth) {
              loginModal.openModal();
            } else {
              openModal();
            }
          }}
        >
          درخواست مشاور
        </Button>
      </div>

      {/*{plpListing?.productJsonLd && (*/}
      {/*    <script*/}
      {/*        id="jsonLD-kilid-plp"*/}
      {/*        type="application/ld+json"*/}
      {/*        dangerouslySetInnerHTML={{__html: plpListing.productJsonLd}}*/}
      {/*    />*/}
      {/*)}*/}
      {/*{plpListing?.searchJsonLd && (*/}
      {/*    <script*/}
      {/*        id="jsonLD-kilid-plp-event"*/}
      {/*        type="application/ld+json"*/}
      {/*        dangerouslySetInnerHTML={{__html: plpListing?.searchJsonLd}}*/}
      {/*    />*/}
      {/*)}*/}
    </>
  );
}

export default observer(MainContent);
